import cytoscape from 'cytoscape';
import {
  COMPOUND_BACKGROUND,
  COMPOUND_CONTENT,
  contextPath,
  DEFAULT_BACKGROUND,
  DEFAULT_NODE_WIDTH,
} from './cy-constant';

// cy Layout configurations :
export const nodeBgWidthSelected = '100%';
export const nodeWidthSelected = '150px';

export const nodeBgWidth = '150%';

export const maleImg = contextPath + '/img/male.jpg';
export const femaleImg = contextPath + '/img/female.jpg';

export const createCss = (userData) => {
  let css = createDefaultCss();
  // // debug-console.log('create css for userData : ', userData);
  userData.forEach((ele) => {
    if (ele.data && ele.group !== 'edges') {
      css = addNodeCss(css, ele);
    }
  });

  // // debug-console.log('css : ', css);
  return css;
};

export const createNodeStyle = (ele) => {
  if (ele.data.id === COMPOUND_BACKGROUND) {
    // // debug-console.log('bg style:');
    return {
      label: '',
      'background-image': createNodeImgUrl(ele),
      shape: 'rectangle',
      // 'min-width': '3240px',
      // 'min-height': '2100px',
      padding: '800',
      // 'padding-right': '1200px',
      // 'padding-left': '1200px',
      // 'padding-top': '1500px',
      // 'padding-bottom': '1000px',
    };
  }

  if (ele.data.id === COMPOUND_CONTENT) {
    // // debug-console.log('content style:');
    return {
      label: '',
      'background-image': null,
      // 'min-width': '2080px',
      // 'min-height': '1400px',
      // padding: '0',
    };
  }
  return { 'background-image': createNodeImgUrl(ele) };
};

export const addNodeCss = (css, ele) => {
  // // debug-console.log('Adding css for: ' + ele.data.id + ' / ' + ele.data.name, ele);

  return css.selector('#' + ele.data.id).css(createNodeStyle(ele));
};

// create Cy Node background Img url - input type is JSON obj with .data
export const createNodeImgUrl = (ele) => {
  if (ele.data.id === COMPOUND_BACKGROUND) {
    return DEFAULT_BACKGROUND;
  }

  if (ele.data.id === COMPOUND_CONTENT) {
    return null;
  }

  let url = ele.data.img;
  if (!url || url === '') {
    if (ele.data.gender === 'f') {
      url = femaleImg;
    } else {
      url = maleImg;
    }
  }
  // // debug-console.log(
  //   '+++ create Cy Node CSS img: ' + (url?.startsWith('http') ? url : url?.substring(0, 25)),
  // );
  return url;
};

const getLabel = (node) => {
  const birthYear = node.data('birthYear');
  const name = node.data('name');
  if (birthYear?.length > 0) {
    return name + ' \n (' + birthYear + ')';
  }
  // // debug-console.log('getLabel: name=' + name);
  if (name) return name;
  // // debug-console.log('getLabel: --- name empty: '+node.id());
  return ' ';
};

export const createDefaultCss = () => {
  return cytoscape
    .stylesheet()
    .selector('node')
    .css({
      // 'background-image' : base64Img,
      // 'background-image': 'data(img)',
      'background-fit': 'contain',
      // 'background-image-opacity': 0.5,
      // 'background-color': '#e4e4e4', // light gray
      // 'background-opacity': 0.2,
      'background-width': nodeBgWidth,
      'background-height': nodeBgWidth,
      // 'background-image-crossorigin': 'anonymous', -> origin error
      'background-image-crossorigin': 'null',
      width: `${DEFAULT_NODE_WIDTH}px`,
      height: '100%',
      // 'padding': '10',
      // 'border-width': 1,
      // 'border-color': 'black',
      'overlay-color': 'red',
      label: getLabel,
      'text-wrap': 'wrap',
      'font-family': 'serif',
      'font-size': '28px',
      'text-margin-y': '-10px', // closer to top
      // 'label': 'data(id)',
      'z-index': 1,
    })
    .selector('node.selected')
    .css(nodeSelected)
    .selector('.hide')
    .css(hiddenStyle)
    .selector('node.ghost')
    .css(ghostStyle)
    .selector('node:parent')
    .css({
      'background-fit': 'contain contain',
      shape: 'round-rectangle', // bottom-round-rectangle , cut-rectangle
      'background-color': '#e4e4e4',
      'background-image-containment': 'inside', // Determines whether background image is within (inside, default) or over top of the node(over).
      'background-clip': 'none',
      'background-fill': 'linear-gradient', // or radial-gradient
      'overlay-color': 'yellow',
      'target-arrow-color': 'red',
      'target-arrow-shape': 'triangle',
      'curve-style': 'haystack',
      'background-opacity': 0.1,
    })
    .selector('edge')
    .css({
      width: 2,
      'line-color': '#ccc',
      'target-arrow-color': 'red',
      'target-arrow-shape': 'triangle',
      'overlay-color': 'red',
      'curve-style': 'taxi',
      'taxi-turn': '20px',
      'taxi-direction': 'vertical',
      'taxi-turn-min-distance': '10px',
      // 'label': 'data(name)',
      'font-family': 'serif',
      'font-size': '26px',
      'z-index': 10,
    })
    .selector('node.leaf')
    .css({
      shape: 'star',
    })
    .selector('edge[weight >= 500], edge.ancient')
    .css({
      'line-color': '#ef4a87', // pink
    })
    .selector('edge.green')
    .css({
      'line-color': 'green',
    })
    .selector('edge.red')
    .css({
      'line-color': 'red',
    })
    .selector('edge.blue')
    .css({
      'line-color': 'blue',
    })
    .selector('edge.selected')
    .css({
      width: 4,
      'target-arrow-color': 'red',
      'target-arrow-shape': 'triangle',
      'curve-style': 'taxi',
      'taxi-turn': '20px',
      'taxi-direction': 'vertical',
      // label: 'data(name)',
    })

    .selector('edge:selected')
    .css({
      'line-color': 'blue',
      'target-arrow-color': 'red',
      'target-arrow-shape': 'triangle',
      'curve-style': 'taxi',
      'taxi-turn': '20px',
      'taxi-direction': 'vertical',
      label: 'data(name)',
    });
  /*
        .selector('node:selected')
    .css({'background-fit' : 'cover cover',
        'background-image-containment' : 'inside', // Determines whether background image is within (inside, default) or over top of the node(over).
        'background-clip' : 'node', 
        // 'overlay-color' : 'yellow',
        // 'background-color': 'yellow',
          'background-width': '130px',
        'background-height': '130px',
        'width': '110px',
        'height': '110px'})	  	  
      */
};

export const nodeSelected = {
  shape: 'ellipse',
  // 'background-color': 'blue',
  'background-width': nodeBgWidthSelected,
  'background-height': nodeBgWidthSelected,
  'background-fit': 'cover cover',
  'background-image-containment': 'inside', // Determines whether background image is within (inside, default) or over top of the node(over).
  width: nodeWidthSelected,
  height: nodeWidthSelected,
  'background-clip': 'node',
  'border-color': '#00d000',
  'border-width': 10,
  'overlay-color': 'yellow',
  'curve-style': 'haystack',
  label: getLabel,
};

export const expandStyle = {
  shape: 'diamond',
  'background-color': 'red',
  width: '170px',
  height: '170px',
};

export const collapseStyle = {
  'background-color': 'yellow',
  width: '20px',
  height: '20px',
};

export const hiddenStyle = {
  display: 'none',
};

export const displayStyle = { display: 'element' };

export const ghostStyle = {
  // The ghost properties allow for creating a ghosting effect, a semitransparent duplicate of the element drawn at an offset.
  'background-color': 'gray',
  width: '100',
  height: '100',
  ghost: 'yes',
  'ghost-offset-x': '3', // The horizontal offset used to position the ghost effect.
  'ghost-offset-y': '5', // The vertical offset used to position the ghost effect.
  'ghost-opacity': 0.5, // The opacity of the ghost effect.
};

// const noGhostStyle = {
//   ghost: 'no',
//   'ghost-offset-x': '0', // The horizontal offset used to position the ghost effect.
//   'ghost-offset-y': '0', // The vertical offset used to position the ghost effect.
//   'ghost-opacity': 0.5, // The opacity of the ghost effect.
//   // 'label': 'data(name)'
// };

export default hiddenStyle;
